import { FC, useMemo } from 'react'
import classNames from 'classnames'
import parse from 'html-react-parser'
import { useLocation } from 'react-router-dom'
import { ROUTE_HOME, ROUTE_STORE_DETAIL } from 'constant'
import { Link, Text } from 'components/atoms'
import { useMachineInfor } from 'stores'

export const Footer = () => {
  const { pathname, search } = useLocation()
  const machineInfor = useMachineInfor(state => state.machineInfor)

  const routes = useMemo(() => {
    const textCre = machineInfor?.credit_dsp?.includes('<img')
      ? machineInfor?.credit_dsp.replace(
          /(src=")/,
          `$1${process.env.REACT_APP_API_IMAGE}/`,
        )
      : machineInfor?.credit_dsp

    return [
      [
        {
          type: 'link',
          text: 'PAPIMO-NET 利用規約',
          href: 'https://papimo.jp/support/rule/',
        },
        {
          type: 'link',
          text: 'PAPIMO-NET プライバシーポリシー',
          href: 'https://papimo.jp/support/privacy/',
        },
        {
          type: 'link',
          text: 'AIスランプウォッチャーとは',
          href: ROUTE_HOME,
        },
      ],
      [
        {
          type: 'link',
          text: 'PAPIMO-NET パチンコ・パチスロ情報サイト',
          href: 'https://papimo.jp/',
        },
        {
          type: 'link',
          text: 'PAPIMO-NET お問合わせ',
          href: 'https://papimo.jp/support/contact/',
        },
        {
          type: 'special',
          text: textCre || '',
          href: '',
        },
      ],
    ]
  }, [machineInfor?.credit_dsp])

  return (
    <div
      className={classNames({
        'flex flex-col gap-[18px] w-full px-[12.5px] pb-[34px]': true,
        'pt-3': pathname.includes(ROUTE_STORE_DETAIL),
        'pt-2': !pathname.includes(ROUTE_STORE_DETAIL),
      })}
    >
      <div className="w-full h-[62px] flex items-center justify-center px-[6px]">
        <div className="w-full h-[1px] bg-borPink" />
      </div>
      <div className="w-full flex flex-col gap-9">
        {routes.map((route, indexR) => (
          <div key={indexR} className="w-full flex flex-col">
            {route.map(({ href, text, type }, index) => {
              if (type === 'link')
                return (
                  <Link key={index} href={href} text={text} target="_blank" />
                )
              if (type === 'special')
                return (
                  <div
                    key={index}
                    className={classNames(
                      'font-notoSans font-medium text-textPink text-[13px] leading-[31.2px]',
                      {
                        hidden: pathname === ROUTE_HOME && search === '',
                      },
                    )}
                  >
                    <RenderHTML text={text} />
                  </div>
                )
              return <Text key={index} text={text} />
            })}
          </div>
        ))}
      </div>
      <div className="w-full h-[103px] flex items-end justify-center">
        <Text
          className="text-sm leading-[17.92px]"
          text="© GLORY NASCA ltd. All right reserved."
        />
      </div>
    </div>
  )
}

const RenderHTML: FC<{ text: string }> = ({ text }) => {
  return <div>{parse(text)}</div>
}
